module.exports = __webpack_public_path__ + "media/alarm.4c754579.mp3";